import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes.container)
  }, [
    _createElementVNode("input", {
      id: _ctx.ID,
      type: "checkbox",
      class: _normalizeClass(_ctx.classes.input),
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onValueChange && _ctx.onValueChange(...args)))
    }, null, 42, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.ID,
      class: _normalizeClass(_ctx.classes.label)
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_2)
  ], 2))
}